var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95536 0 0 8.95536 0 20C0 31.0446 8.95536 40 20 40C31.0446 40 40 31.0446 40 20C40 8.95536 31.0446 0 20 0ZM21.4286 29.6429C21.4286 29.8393 21.2679 30 21.0714 30H18.9286C18.7321 30 18.5714 29.8393 18.5714 29.6429V17.5C18.5714 17.3036 18.7321 17.1429 18.9286 17.1429H21.0714C21.2679 17.1429 21.4286 17.3036 21.4286 17.5V29.6429ZM20 14.2857C19.4393 14.2743 18.9053 14.0435 18.5128 13.6429C18.1203 13.2422 17.9004 12.7037 17.9004 12.1429C17.9004 11.582 18.1203 11.0435 18.5128 10.6429C18.9053 10.2422 19.4393 10.0114 20 10C20.5607 10.0114 21.0947 10.2422 21.4872 10.6429C21.8797 11.0435 22.0996 11.582 22.0996 12.1429C22.0996 12.7037 21.8797 13.2422 21.4872 13.6429C21.0947 14.0435 20.5607 14.2743 20 14.2857Z",
    fill: "#FD8499"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconPink);
export default __webpack_public_path__ + "static/media/infoIconPink.a08bc9dfb6ca39695aedc126c2c7268d.svg";
export { ForwardRef as ReactComponent };